import { PRIMARY_COLOR } from 'constants/theme';
import styled from 'styled-components';

export const FormItemsInTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 1200px;
  overflow-x: auto;

  .table {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 2fr 1fr 1fr 1fr;
    row-gap: 10px;
    column-gap: 4px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
  }

  .btn_submit {
    color: ${PRIMARY_COLOR};
  }
`;
